export const SONG_RECEPTION = Object.freeze([
  {
    Track: "1",
    Author: "Roisin O'Connor & Elizabeth Aubrey",
    Platform: "The Independent",
    URL: "https://www.independent.co.uk/arts-entertainment/music/reviews/metallica-blacklist-review-common-album-b1916443.html",
    Quote: "But Alessia Cara triumphs ... abandoning her R&B roots in place of a <proficiency>snarling, agile vocal performance,</proficiency> with a <genre>delicious pinch of pop-punk</genre> on the verses providing additional spice.",
    Sentiment: "1"
  },
  {
    Track: "2",
    Author: "Sam Walker-Smart",
    Platform: "Clash",
    URL: "https://www.clashmusic.com/reviews/v-a-the-metallica-blacklist/",
    Quote: "Mac DeMarco['s] hella fun stab at 'Enter Sandman' add[s] some <genre>garage rock panache</genre> to this guitar shop classic. It's heavy, it's goofy, and he sounds like he's having the time of his life with it.",
    Sentiment: "1"
  },
  {
    Track: "2",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Mac DeMarco's <proficiency>spirited if wobbly</proficiency> attempt to give it its full metal dues",
    Sentiment: "-1"
  },
  {
    Track: "2",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "(Then again, <loyalty>nobody, including ... Mac DeMarco, go very afield</loyalty> with that one.)",
    Sentiment: "-1"
  },
  {
    Track: "3",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Ghost transform Enter Sandman into a <genre>euphoric slice of 70s hard rock</genre> with <instrumentation>snarling riffs, piano-driven melodies</instrumentation> and Papa's witchy, layered vocals. ",
    Sentiment: "1"
  },
  {
    Track: "3",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Ghost have definitely been waiting to cover \"Enter Sandman\" forever and it comes out with their <memorability>distinct organ-heavy energy</memorability>.",
    Sentiment: "1"
  },
  {
    Track: "3",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "with the rear of the field made up by Ghost's <genre>gloss-rock pantomime</genre> version",
    Sentiment: "-1"
  },
  {
    Track: "3",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "(Then again, <loyalty>nobody, including Ghost ... go very afield</loyalty> with that one.)",
    Sentiment: "-1"
  },
  {
    Track: "4",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Colombia's <reputation>Grammy-collecting megastar</reputation>, Juanes, <genre>funks up Enter Sandman with a bit of Latin flavour</genre>",
    Sentiment: "1"
  },
  {
    Track: "4",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "...but you'd still be <memorability>hard-pressed to remember it</memorability> among the numerous other versions. ",
    Sentiment: "-1"
  },
  {
    Track: "4",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "...Juanes, the Colombian pop musician who returns to his roots for a <genre>reggaeton</genre> \"Enter Sandman\".",
    Sentiment: "1"
  },
  {
    Track: "4",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "(Then again, <loyalty>nobody, including  ... Juanes ... go very afield</loyalty> with that one.)",
    Sentiment: "-1"
  },
  {
    Track: "5",
    Author: "Roisin O'Connor & Elizabeth Aubrey",
    Platform: "The Independent",
    URL: "https://www.independent.co.uk/arts-entertainment/music/reviews/metallica-blacklist-review-common-album-b1916443.html",
    Quote: "Rina Sawayama is an <genre>industrial queen</genre> in a maelstrom of <instrumentation>crunchy riffs and chugging bass.</instrumentation>",
    Sentiment: "1"
  },
  {
    Track: "5",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "<genre>pop-industrial</genre> (Rina Sawayama's \"Enter Sandman\")",
    Sentiment: "1"
  },
  {
    Track: "5",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Rina Sawayama turns the same song into a <genre>thrash/dance tune.</genre>",
    Sentiment: "1"
  },
  {
    Track: "5",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "In the battle for 'Enter Sandman', Rina Sawayama's <genre>crazed electro-storm</genre> ... triumphs",
    Sentiment: "1"
  },
  {
    Track: "5",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "The spirit of the release is better captured by the <genre>thumping, maximalist pop</genre> of Rina Sawayama's \"Enter Sandman\"",
    Sentiment: "1"
  },
  {
    Track: "6",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "It's not that Weezer's \"Sandman\" ... (among others) are bad; instead, they're simply uninteresting. <loyalty>They don't add anything new.</loyalty> \"It's a little stock,\" in other words.",
    Sentiment: "-1"
  },
  {
    Track: "6",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "But the hits outweigh the misses by a mile, especially when you've got <reputation>hitters like ... Weezer ... in the line-up</reputation>.",
    Sentiment: "1"
  },
  {
    Track: "6",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "<memorability>Don't miss</memorability> more covers by ... Weezer",
    Sentiment: "1"
  },
  {
    Track: "6",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Weezer's <instrumentation>power-chord overload</instrumentation>",
    Sentiment: "1"
  },
  {
    Track: "6",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "Weezer, who scored an improbable hit in 2018 by covering Toto, <loyalty>sleepwalk through a carbon copy of \"Enter Sandman\" that follows the original note-for-note</loyalty> except when they interpolate a lick from \"Buddy Holly.\"",
    Sentiment: "-1"
  },
  {
    Track: "6",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "Weezer doing \"Enter Sandman\" <reputation>sounds, well, exactly like Weezer</reputation> covering \"Enter Sandman\"",
    Sentiment: "1"
  },
  {
    Track: "7",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Both <interpretation>trump Sam Fender's soul effort</interpretation>",
    Sentiment: "-1"
  },
  {
    Track: "8",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Closely related, Jason Isbell and The 400 Unit turn Sad But True into a <genre>boozy roadhouse shakedown</genre>.",
    Sentiment: "1"
  },
  {
    Track: "8",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Jason Isbell and The 400 Unit ... throw their <genre>oversized cowboy hats in the ring</genre>.",
    Sentiment: "1"
  },
  {
    Track: "8",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "but face stiff competition from Jason Isbell And The 400 Unit (<genre>demented skiffle rock</genre>)",
    Sentiment: "1"
  },
  {
    Track: "8",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "Jason Isbell and the 400 Unit turn \"Sad But True\" into a <genre>roots rave-up</genre>",
    Sentiment: "1"
  },
  {
    Track: "9",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "but face stiff competition from ... the Mexican Institute Of Sound (<genre>carnival freak rave</genre>)",
    Sentiment: "1"
  },
  {
    Track: "10",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "It's not that ... Royal Blood's \"Sad,\" ... (among others) are bad; instead, <loyalty>they're simply uninteresting. They don't add anything new.</loyalty> \"It's a little stock,\" in other words.",
    Sentiment: "-1"
  },
  {
    Track: "10",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "But the hits outweigh the misses by a mile, especially when you've got <reputation>hitters like Royal Blood ... in the line-up</reputation>.",
    Sentiment: "1"
  },
  {
    Track: "10",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Royal Blood <proficiency>continue to sound bigger</proficiency> <reputation>than their two members</reputation> on a worshipful \"Sad But True\"",
    Sentiment: "1"
  },
  {
    Track: "10",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Royal Blood ... <loyalty>channelling faithful Kirk Hammett riffage</loyalty>",
    Sentiment: "1"
  },
  {
    Track: "11",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "St. Vincent's <genre>hard-edged electro-rock version</genre> of \"Sad But True\" stand[s] out",
    Sentiment: "1"
  },
  {
    Track: "11",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Other notable performances include St. Vincent's <genre>smouldering, pseudo-industrial take</genre> on Sad But True ",
    Sentiment: "1"
  },
  {
    Track: "11",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "St. Vincent is a confirmed metalhead, but her <genre>synth-pop \"Sad But True\" won't please metal fans</genre> or her own listeners.",
    Sentiment: "-1"
  },
  {
    Track: "11",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "St. Vincent ... taking it for an <genre>art-pop frolic</genre> through an <genre>industrial wasteland</genre>",
    Sentiment: "1"
  },
  {
    Track: "11",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "St. Vincent creates <genre>hazy electro-rock weirdness</genre> with it",
    Sentiment: "1"
  },
  {
    Track: "12",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "White Reaper's <instrumentation>chugging</instrumentation> take on \"Sad But True\" is <loyalty>especially true to form</loyalty>",
    Sentiment: "1"
  },
  {
    Track: "12",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "The collection features everything from <loyalty>safe recreations</loyalty> (White Reaper's \"Sad But True\")",
    Sentiment: "1"
  },
  {
    Track: "12",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "<memorability>Don't miss</memorability> more covers by ... White Reaper. ",
    Sentiment: "1"
  },
  {
    Track: "14",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Biffy Clyro's Holier Than Thou – an onslaught of <instrumentation>surging beats, razor-wire riffing</instrumentation> and a <composition>supernova-sized breakdown</composition>.",
    Sentiment: "1"
  },
  {
    Track: "14",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Biffy Clyro make an early claim on 'Holier Than Thou' with a <interpretation>sophisticated yet brutal reading</interpretation> plus <composition>anthemic coda</composition>",
    Sentiment: "1"
  },
  {
    Track: "15",
    Author: "Sam Walker-Smart",
    Platform: "Clash",
    URL: "https://www.clashmusic.com/reviews/v-a-the-metallica-blacklist/",
    Quote: "Mad Aussies The Chats bring some <interpretation>snot and snarl</interpretation> to 'Holier Than Though,' morphing the original's bruising beat into a <genre>lost punk classic circa 1977</genre>.",
    Sentiment: "1"
  },
  {
    Track: "15",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "only to be assaulted in a dark alleyway by <genre>speed-punk gangs</genre> The Chats",
    Sentiment: "1"
  },
  {
    Track: "16",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Off! turn in a positively blistering version that anyone unfamiliar with the original could credibly mistake for an <genre>old-school punk anthem</genre>.",
    Sentiment: "1"
  },
  {
    Track: "16",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "<memorability>Don't miss</memorability> more covers by ... Off!",
    Sentiment: "1"
  },
  {
    Track: "16",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "only to be assaulted in a dark alleyway by <genre>speed-punk gangs</genre> ... OFF!",
    Sentiment: "1"
  },
  {
    Track: "17",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "Elsewhere, you get <genre>snotty garage rock</genre> (PUP's \"Holier Than Thou Art\")",
    Sentiment: "1"
  },
  {
    Track: "17",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "<genre>Don't miss</genre> more covers by Pup",
    Sentiment: "1"
  },
  {
    Track: "17",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "only to be assaulted in a dark alleyway by <genre>speed-punk gangs</genre> ... PUP",
    Sentiment: "1"
  },
  {
    Track: "18",
    Author: "Roisin O'Connor & Elizabeth Aubrey",
    Platform: "The Independent",
    URL: "https://www.independent.co.uk/arts-entertainment/music/reviews/metallica-blacklist-review-common-album-b1916443.html",
    Quote: "<reputation>Slipknot frontman</reputation> Corey Taylor's gut-wrenching roars on \"Holier Than Thou\" are <reputation>just as impressive as James Hetfield's</reputation>.",
    Sentiment: "1"
  },
  {
    Track: "18",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "Additionally, there are also some nifty moments—like the <composition>\"Whiplash\" tease at the end of Corey Taylor's ... \"Holier,\"</composition>",
    Sentiment: "1"
  },
  {
    Track: "18",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "Corey Taylor's <memorability>otherwise-pedestrian</memorability> take on \"Holier,\"",
    Sentiment: "-1"
  },
  {
    Track: "18",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "But the hits outweigh the misses by a mile, especially when you've got <reputation>hitters like ... Corey Taylor</reputation> in the line-up.",
    Sentiment: "1"
  },
  {
    Track: "18",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "<reputation>Corey Taylor sounds like Corey Taylor</reputation> on \"Holier Than Thou\"",
    Sentiment: "1"
  },
  {
    Track: "18",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "before having it ferociously wrestled from their grasp to present to their <reputation>ruler and ringleader, Corey Taylor</reputation>",
    Sentiment: "1"
  },
  {
    Track: "18",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "Slipknot's Corey Taylor clearly loves \"Holier Than Thou,\" but his <loyalty>note-perfect interpretation feels out of place</loyalty>.",
    Sentiment: "-1"
  },
  {
    Track: "19",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Cage The Elephant's <interpretation>take on 'The Unforgiven',</interpretation> giving James Hetfield's struggles with religion upon his mother's death a <genre>cultured psych-rock soundtrack</genre>, does the trick straight off the bat.",
    Sentiment: "1"
  },
  {
    Track: "20",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "<genre>Indian electronica and rap</genre> (\"The Unforgiven\" from Vishal Dadlani and DIVINE)",
    Sentiment: "1"
  },
  {
    Track: "20",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Bollywood legend Vishal Dadlani valiantly takes on \"The Unforgiven\", but it's too sappy to be worth more than one listen.",
    Sentiment: "-1"
  },
  {
    Track: "20",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Yet further variants on the <genre>doom ballad theme from the likes of Vishal Dadlani & Divine (intense)</genre> ... feel like vast overkill.",
    Sentiment: "-1"
  },
  {
    Track: "21",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Diet Cig sounds like Phoebe Bridgers if she listened to more Wolf Alice, but <interpretation>somehow not as cool as that should be.</interpretation>",
    Sentiment: "-1"
  },
  {
    Track: "21",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Yet further variants on the <genre>doom ballad theme from the likes of ... Diet Cig (grungy)</genre> ... feel like vast overkill.",
    Sentiment: "-1"
  },
  {
    Track: "22",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "...nifty moments—like... <composition>Meechy Darko's song-stealing verse</composition> during Flatbush Zombies's \"The Unforgiven,\"",
    Sentiment: "1"
  },
  {
    Track: "22",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Flatbush Zombies turn 'The Unforgiven' into <genre>gnarled electro-rap</genre>",
    Sentiment: "1"
  },
  {
    Track: "22",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "Flatbush Zombies build a <genre>woozy hip-hop epic</genre> <composition>around a pitch-shifted sample</composition> of \"The Unforgiven,\" splashing <interpretation>wrenchingly autobiographical verses</interpretation> on James Hetfield's vaguely anti-authoritarian canvas.",
    Sentiment: "1"
  },
  {
    Track: "23",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Ha*Ash's version of The Unforgiven – a <genre>dreamy slice of acoustic balladry</genre> that feels like the theme to a mythic quest.",
    Sentiment: "1"
  },
  {
    Track: "23",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Yet further variants on the <genre>doom ballad theme from the likes of ... Ha*Ash (folk-poppy)</genre> ... feel like vast overkill.",
    Sentiment: "-1"
  },
  {
    Track: "25",
    Author: "Sam Walker-Smart",
    Platform: "Clash",
    URL: "https://www.clashmusic.com/reviews/v-a-the-metallica-blacklist/",
    Quote: "Ghanaian-American singer-songwriter Moses Sumney brings <interpretation>soul and pathos</interpretation> to 'The Unforgiven,' a true highlight and the most beautiful moment of the set. ",
    Sentiment: "1"
  },
  {
    Track: "25",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "Moses Sumney's <interpretation>delicate and achingly beautiful take</interpretation> on \"The Unforgiven\"",
    Sentiment: "1"
  },
  {
    Track: "25",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Yet further variants on the <genre>doom ballad theme from the likes of ... Moses Sumney (soulful and fiddly-fingered)</genre> feel like vast overkill.",
    Sentiment: "-1"
  },
  {
    Track: "25",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "and the <interpretation>disquieting beauty</genre> of Moses Sumney's \"The Unforgiven.\"",
    Sentiment: "1"
  },
  {
    Track: "26",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "to left-field rejiggering (J Balvin's <genre>rap reimagining</genre> of \"Wherever I May Roam\")",
    Sentiment: "1"
  },
  {
    Track: "26",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "...nifty moments—like... Tainy's <composition>nice-trick production for J Balvin's \"Wherever\" that cuts up the original's guitar solo into its own hook and then morphs it into an emergency siren</composition>",
    Sentiment: "1"
  },
  {
    Track: "26",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "But by the time J Balvin is <genre>rapping</genre> \"Wherever I May Roam\" in Spanish, all bets are off.",
    Sentiment: "1"
  },
  {
    Track: "26",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "[T]here's a refreshing stretch where J Balvin ... <remould[s] the eastern textures of 'Wherever I May Roam' into </genre>modernist dancefloor destroyers</genre>",
    Sentiment: "1"
  },
  {
    Track: "26",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "<reputation>Reggaeton hitmaker</reputation> J Balvin drops off a version of \"Wherever I May Roam\" <proficiency>so half-assed that it seems like he accidentally delivered the demo.</proficiency>",
    Sentiment: "-1"
  },
  {
    Track: "27",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Chase & Status bring in Background Gee for Wherever I May Roam, showcasing some <genre>filthy hip hop grooves</genre>",
    Sentiment: "1"
  },
  {
    Track: "27",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Chase & Status bring in Background Gee for Wherever I May Roam ... but <composition>[leave] listeners waiting for a huge payoff that never arrives.</composition>",
    Sentiment: "-1"
  },
  {
    Track: "27",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "[T]here's a refreshing stretch where ... Chase & Status ... remould the eastern textures of 'Wherever I May Roam' into <genre>modernist dancefloor destroyers</genre>",
    Sentiment: "1"
  },
  {
    Track: "28",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "[T]here's a refreshing stretch ... The Neptunes ... remould the eastern textures of 'Wherever I May Roam' into </genre>modernist dancefloor destroyers</genre>",
    Sentiment: "1"
  },
  {
    Track: "29",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Jon Pardi throw[s his] <genre>oversized cowboy [hat]</genre> in the ring.",
    Sentiment: "1"
  },
  {
    Track: "30",
    Author: "Roisin O'Connor & Elizabeth Aubrey",
    Platform: "The Independent",
    URL: "https://www.independent.co.uk/arts-entertainment/music/reviews/metallica-blacklist-review-common-album-b1916443.html",
    Quote: "French producer SebastiAn brings some <genre>Prince and George-Michael-indebted funk</genre> to \"Don't Tread On Me\"",
    Sentiment: "1"
  },
  {
    Track: "30",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "SebastiAn's stupid-fun <genre>disco-infused house</genre> <composition>mash-up</composition> of \"Don't Tread On Me\" and \"Nothing Else Matters\"",
    Sentiment: "1"
  },
  {
    Track: "30",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "French producer SebastiAn, ... throws himself fully into the concept by <composition>mashing up two tracks</composition> into an <genre>electro-orchestral funk frippery</genre> clumsily titled 'Don't Tread On Else Matters'.",
    Sentiment: "1"
  },
  {
    Track: "31",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Later, Portugal. The Man bring a certain <genre>Pac-Man element to their very metal</genre> 'Don't Tread On Me'",
    Sentiment: "1"
  },
  {
    Track: "32",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "It's not that ... Volbeat's \"Don't Tread\" (among others) are bad; instead, <loyalty>they're simply uninteresting. They don't add anything new.</loyalty> \"It's a little stock,\" in other words.",
    Sentiment: "-1"
  },
  {
    Track: "32",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Volbeat must be sick of all the comparisons by now, because their \"Don't Tread On Me\" features one of The Blacklist's <loyalty>most faithful renditions.</loyalty>",
    Sentiment: "1"
  },
  {
    Track: "33",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "Mongolian marauders The Hu check in with a slamming Through The Never, <interpretation>sung in their native tongue and played with the wild, surging ferocity of a bloodthirsty horde riding into battle</interpretation>.",
    Sentiment: "1"
  },
  {
    Track: "33",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "But it's The Hu's <memorability>Mongolian-language \"Through The Never\"</memorability> that will send fans into fits of musical ecstasy.",
    Sentiment: "1"
  },
  {
    Track: "34",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "<reputation>rising R&B star</reputation> Tomi Owó, whose version of \"Through The Never\" manages to <instrumentation>balance metal riffs with her angelic voice</instrumentation>.",
    Sentiment: "1"
  },
  {
    Track: "35",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "Phoebe Bridgers' <interpretation>especially delicate reading</interpretation>",
    Sentiment: "1"
  },
  {
    Track: "35",
    Author: "Sam Walker-Smart",
    Platform: "Clash",
    URL: "https://www.clashmusic.com/reviews/v-a-the-metallica-blacklist/",
    Quote: "For something completely different, we have Phoebe Bridgers <genre>baroque-pop</genre> go at 'Nothing Else Matters,' <instrumentation>twinkling keys and somber strings</instrumentation> adding some welcome ambiance to the power ballad.",
    Sentiment: "1"
  },
  {
    Track: "35",
    Author: "Roisin O'Connor & Elizabeth Aubrey",
    Platform: "The Independent",
    URL: "https://www.independent.co.uk/arts-entertainment/music/reviews/metallica-blacklist-review-common-album-b1916443.html",
    Quote: "On \"Nothing Else Matters\", Bridgers opens with a <instrumentation>startlingly beautiful piano motif</instrumentation> reminiscent of Chilly Gonzales's delicate work. Where many have attempted to capture the imposing volume Metallica brought to The Black Album, Bridgers <interpretation>takes the stripped-down route, with magnificent results</interpretation>.",
    Sentiment: "1"
  },
  {
    Track: "35",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "Phoebe Bridgers, whose <interpretation>stunning and haunting</interpretation> <genre>chamber music reading</genre> of \"Nothing\" is the best of the dozen ...",
    Sentiment: "1"
  },
  {
    Track: "35",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Phoebe Bridgers is here to chill things out with her <instrumentation>piano</instrumentation> and <genre>indie-rock production</genre>",
    Sentiment: "1"
  },
  {
    Track: "35",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Phoebe Bridgers produces a <genre>far more gorgeous, vaporous junk</genre> <instrumentation>piano</instrumentation> take",
    Sentiment: "1"
  },
  {
    Track: "35",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "Phoebe Bridgers' delicate version <interpretation>feels like a Punisher outtake</interpretation>",
    Sentiment: "1"
  },
  {
    Track: "35",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "Phoebe Bridgers (<instrumentation>piano and strings</instrumentation>)",
    Sentiment: "1"
  },
  {
    Track: "36",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "a <uniqueness>staggering 12 versions</uniqueness> of \"Nothing Else Matters\" by everyone from <reputation>Miley Cyrus (appearing along with Yo-Yo Ma, Elton John, and other friends)</reputation> ... and more.",
    Sentiment: "-1"
  },
  {
    Track: "36",
    Author: "Sam Walker-Smart",
    Platform: "Clash",
    URL: "https://www.clashmusic.com/reviews/v-a-the-metallica-blacklist/",
    Quote: "<reputation>Miley Cyrus, Elton John, the Chili's Chad Smith, and Metallica's own Robert Trujillo join forces</reputation> for an absolutely stacked cover of 'Nothing Else Matters,' Cyrus channeling Stevie Nicks for some <proficiency>serious 80s wind-machine worthy epicness</proficiency>.",
    Sentiment: "1"
  },
  {
    Track: "36",
    Author: "Roisin O'Connor & Elizabeth Aubrey",
    Platform: "The Independent",
    URL: "https://www.independent.co.uk/arts-entertainment/music/reviews/metallica-blacklist-review-common-album-b1916443.html",
    Quote: "We'd already seen Miley Cyrus spark calls for her to abandon pop altogether in favour of a new era as a fully fledged rock star, thanks to her <reputation>Glastonbury performance of \"Nothing Else Matters\"</reputation>. Her recorded version is just as impressive[.]",
    Sentiment: "1"
  },
  {
    Track: "36",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "worth checking out, [...] <reputation>Miley Cyrus' fascinating mess—featuring six artists including Elton John, Yo-Yo Ma, and Chad Smith</reputation>",
    Sentiment: "1"
  },
  {
    Track: "36",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "<reputation>Miley Cyrus's collaboration with Elton John and others</reputation> on Nothing Else Matters is one of the more memorable tracks",
    Sentiment: "1"
  },
  {
    Track: "36",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "All the attention is right on the centre of the album. It's where <reputation>Miley Cyrus, Elton John, Yo-yo Ma and Chad Smith of Red Hot Chili Peppers deliver the star take</reputation>. Miley Cyrus has reinvented herself several times at this point, but her recent transformation into The Hard Rock Queen of Karaoke has been unexpected and genuinely great. She has a harsh edge on her voice that has been hiding up to this point, a <interpretation>bluesy rasp that calls to mind PJ Harvey, Courtney Barnett and James Hetfield's own bark</interpretation>. As their version of \"Nothing Else Matters\" swells to its climax, it's clear that this is the only track on The Blacklist that can actually be compared to the original.",
    Sentiment: "1"
  },
  {
    Track: "36",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "The <reputation>marquee names are instantly apparent: Miley Cyrus ropes in Elton John and Chad Smith (among others)</reputation>, complete with <composition>unnecessary violin solo</composition>",
    Sentiment: "-1"
  },
  {
    Track: "36",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "Miley Cyrus <reputation>enlists Elton John and Yo-Yo Ma for no reason other than she can</reputation>",
    Sentiment: "1"
  },
  {
    Track: "36",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "Current covers queen Miley Cyrus assembles an <reputation>all-star cast for her version,\nincluding Eton John, Red Hot Chili Peppers drummer Chad Smith and current Metallica bassist Robert Trujillo,</reputation> her voice at the <proficiency>perfect grit</proficiency> for the iconic ballad.",
    Sentiment: "1"
  },
  {
    Track: "37",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "<reputation>Depeche Mode's Dave Gahan</reputation> was born to sing it, swathed in an <genre>electronic miasma</genre>.",
    Sentiment: "1"
  },
  {
    Track: "37",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "<reputation>Depeche Mode singer Dave Gahan</reputation> (<genre>maximum lounge crooner</genre>)",
    Sentiment: "1"
  },
  {
    Track: "42",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "a <uniqueness>staggering 12 versions</uniqueness> of \"Nothing Else Matters\" by everyone from ... My Morning Jacket ... and more.",
    Sentiment: "-1"
  },
  {
    Track: "42",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "My Morning Jacket turning it into a <genre>lighthearted ditty</genre> that's ready-made for car commercials.",
    Sentiment: "-1"
  },
  {
    Track: "42",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "But the bottom has to be My Morning Jacket, who turn \"Nothing Else Matters\" into a <genre>pop rock tune that sounds weak and lacking</genre> in bite at the same time. It's the soundtrack to a bad commercial interrupting your YouTube playlist.",
    Sentiment: "-1"
  },
  {
    Track: "42",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Kudos to My Morning Jacket and (oh yes) Roxette for banging out <genre>pop versions below four minutes</genre>",
    Sentiment: "1"
  },
  {
    Track: "42",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "My Morning Jacket (<reputation>couldn't sound more MMJ</reputation>)",
    Sentiment: "1"
  },
  {
    Track: "43",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "<reputation>Swedish pop pioneers Roxette</reputation> (do the rest, please)",
    Sentiment: "1"
  },
  {
    Track: "44",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "a <uniqueness>staggering 12 versions</uniqueness> of \"Nothing Else Matters\" by everyone from ... Darius Rucker and more.",
    Sentiment: "-1"
  },
  {
    Track: "44",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "Darius Rucker (<genre>frat dude country in full Nashvegas mode</genre>)",
    Sentiment: "1"
  },
  {
    Track: "45",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "Chris Stapleton's has a <composition>cool jam at the end</composition>",
    Sentiment: "1"
  },
  {
    Track: "45",
    Author: "Joe Daly",
    Platform: "Metal Hammer",
    URL: "https://www.loudersound.com/reviews/the-metallica-blacklist-thrash-icons-landmark-album-gets-covered-across-the-musical-spectrum",
    Quote: "<reputation>country legend</reputation> Chris Stapleton taps into the <interpretation>gritty defiance of the original with a mean and dusty</interpretation> eight-minute version that rises to the top of the …Blacklist heap",
    Sentiment: "1"
  },
  {
    Track: "45",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "Chris Stapleton ... throw[s his] <genre>oversized cowboy [hat]</genre> in the ring.",
    Sentiment: "1"
  },
  {
    Track: "45",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "there are few more dispiriting moments in music than when you realise ...  that country blues croaker Chris Stapleton is now going to wang on for over eight [minutes].",
    Sentiment: "-1"
  },
  {
    Track: "46",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "a <uniqueness>staggering 12 versions</uniqueness> of \"Nothing Else Matters\" by everyone from ... TRESOR ... and more.",
    Sentiment: "-1"
  },
  {
    Track: "47",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "The <uniqueness>least-covered songs</uniqueness> ... stand out [such as] Goodnight, Texas' <interpretation>woodsy version</interpretation> of \"Of Wolf and Man\"",
    Sentiment: "1"
  },
  {
    Track: "47",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Special mention must go to Goodnight, Texas ... <uniqueness>the only [act] to offer to cover 'Of Wolf And Man'</uniqueness>",
    Sentiment: "1"
  },
  {
    Track: "47",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "On a 53-track album, they can't all be winners ... A group called Goodnight, Texas brings a <genre>stomp-clap-hey</genre> to \"Of Wolf and Man.\"",
    Sentiment: "-1"
  },
  {
    Track: "48",
    Author: "Sam Walker-Smart",
    Platform: "Clash",
    URL: "https://www.clashmusic.com/reviews/v-a-the-metallica-blacklist/",
    Quote: "IDLES pummel 'The God That Failed' into their wheelhouse, <instrumentation>snarling guitars and sparse bass</instrumentation> <interpretation>transforming the song into something wholly new and completely thrilling</interpretation>. ",
    Sentiment: "1"
  },
  {
    Track: "48",
    Author: "Max Morin",
    Platform: "Metal Injection",
    URL: "https://metalinjection.net/reviews/metallica-the-metallica-blacklist",
    Quote: "IDLES insert British <genre>gutter punk energy</genre> into their cover of \"The God That Failed\", already one of the heaviest songs on The Black Album",
    Sentiment: "1"
  },
  {
    Track: "48",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "IDLES deliver a <interpretation>sonic slap in the face</interpretation> with 'The God That Failed'",
    Sentiment: "1"
  },
  {
    Track: "48",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "IDLES turn \"The God That Failed\" into a <genre>bug-eyed post-punk exorcism</genre>",
    Sentiment: "1"
  },
  {
    Track: "50",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "Cherry Glazzer covers \"My Friend of Misery\" as <genre>stiffish New Wave guitar rock</genre>",
    Sentiment: "-1"
  },
  {
    Track: "52",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "Kamasi Washington's <genre>spacy grooves</genre> on \"My Friend Misery\"",
    Sentiment: "1"
  },
  {
    Track: "52",
    Author: "Roisin O'Connor & Elizabeth Aubrey",
    Platform: "The Independent",
    URL: "https://www.independent.co.uk/arts-entertainment/music/reviews/metallica-blacklist-review-common-album-b1916443.html",
    Quote: "jazz virtuoso Kamasi Washington's <interpretation>transcendent take</interpretation> on \"My Friend of Misery\"",
    Sentiment: "1"
  },
  {
    Track: "52",
    Author: "Brad Sanders",
    Platform: "Pitchfork",
    URL: "https://pitchfork.com/reviews/albums/metallica-the-metallica-blacklist/",
    Quote: "Kamasi Washington pulls off the most impressive feat of the record, discovering a <genre>swirling spiritual jazz workout</genre> in the <uniqueness>little-loved \"My Friend of Misery\"</uniqueness\" and enlisting vocalist Patrice Quinn to <interpretation>breathe new life</interpretation> into Hetfield's cynical lyric.",
    Sentiment: "1"
  },
  {
    Track: "52",
    Author: "Joe Gross",
    Platform: "The Rolling Stone",
    URL: "https://www.rollingstone.com/music/music-album-reviews/the-metallica-blacklist-1221950/",
    Quote: "Kamasi Washington turns it into shockingly <genre>great electric fusion</genre> with singer Patrice Quinn reworking James Hetfield's lyrics into something for the Village Vanguard.",
    Sentiment: "1"
  },
  {
    Track: "53",
    Author: "Fred Thomas",
    Platform: "AllMusic",
    URL: "https://www.allmusic.com/album/the-metallica-blacklist-mw0003548306",
    Quote: "The <uniqueness>least-covered songs ... stand out</uniqueness> [such as] Rodrigo y Gabriela's <instrumentation>precision acoustic instrumental</instrumentation> take on \"The Struggle Within\"",
    Sentiment: "1"
  },
  {
    Track: "53",
    Author: "Steve Lampiris",
    Platform: "The Line of Best Fit",
    URL: "https://www.thelineofbestfit.com/reviews/albums/metallica-the-blacklist-album-review",
    Quote: "Rodrigo y Gabriela's <genre>impressive flamenco transformation</genre> of \"The Struggle Within\"",
    Sentiment: "1"
  },
  {
    Track: "53",
    Author: "Mark Beaumont",
    Platform: "NME",
    URL: "https://www.nme.com/reviews/album/various-artists-the-metallica-blacklist-review-black-album-3042648",
    Quote: "Special mention must go to ... Rodrigo Y Gabriela, the <uniqueness>only [act] to offer to cover  ... 'The Struggle Within'</uniqueness>",
    Sentiment: "1"
  },
])